module.exports = __webpack_public_path__ + "/images/ico-bandera-br.7361950.svg";